import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import checkMarkSVG from "../../../assets/images/icons/checkmark.svg";
import PropTypes from "prop-types";
import { UncontrolledPopover, PopoverHeader, PopoverBody } from "reactstrap";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import fileguideIcon from "../../../assets/images/icons/fileguide_colored.svg";

const fileChecks = [
  {
    title: "FileCheck",
    key: "filecheck",
    description: "FileCheck description",
    iconURL: "https://cdn.myfolie.de/media/products/filecheck.png",
  },
  {
    title: "Production Data",
    key: "productiondata",
    description: "Production Data description",
    iconURL: "https://cdn.myfolie.de/media/products/productiondata.png",
  },
  {
    title: "Design Service",
    key: "design-service",
    description: "Design Service description",
    iconURL: "https://cdn.myfolie.de/media/products/productiondata.png",
    disabled: true,
  },
];

class FileCheckField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  setModalValue(key) {
    const { input } = this.props;
    input.onChange(key);
    this.toggle();
  }

  renderPopoverContent(key) {
    if (key === "filecheck") {
      return this.context.t("Filecheck.Filecheck.Popover");
    } else if (key === "productiondata") {
      return this.context.t("Filecheck.ProductionData.Popover");
    } else if (key === "design-service") {
      return this.context.t("Filecheck.DesignService.Popover");
    }
  }

  renderFileCheckDescription(key) {
    if (key === "filecheck") {
      return this.context.t("Filecheck.Filecheck.Description");
    } else if (key === "productiondata") {
      return this.context.t("Filecheck.ProductionData.Description");
    } else if (key === "design-service") {
      return this.context.t("Filecheck.DesignService.Description");
    }
  }

  renderFileCheckTitle(key) {
    if (key === "filecheck") {
      return this.context.t("Filecheck.Filecheck.Title");
    } else if (key === "productiondata") {
      return this.context.t("Filecheck.ProductionData.Title");
    } else if (key === "design-service") {
      return this.context.t("Filecheck.DesignService.Title");
    }
  }

  render() {
    const {
      input: { value, onChange },
      itemsClassName,
      language,
    } = this.props;
    const placeholder = "https://cdn.myfolie.de/media/20x20.png";
    const _itemsClassName = itemsClassName ? " " + itemsClassName : "";
    return (
      <div>
        {fileChecks.map((fileCheck, index) => {
          const isChecked = fileCheck.key === value;

          return (
            <div key={`filecheck_${index}`}>
              <Row
                className={
                  "filecheck-field-label" +
                  _itemsClassName +
                  (isChecked ? " checked" : "") +
                  (fileCheck.disabled ? " disabled" : "")
                }
                htmlFor={fileCheck.key}
                onClick={() => !fileCheck.disabled && onChange(fileCheck.key)}
                id={`filecheck_${index}_id`}
              >
                <Col
                  xs={3}
                  className={
                    "filecheck-field-icon-container" +
                    (fileCheck.disabled ? " disabled" : "")
                  }
                >
                  <img
                    src={fileCheck.iconURL || placeholder}
                    className={"filecheck-field-icon"}
                    alt="filecheck icon"
                    loading="lazy"
                  />
                  {isChecked && (
                    <img
                      src={checkMarkSVG}
                      className="filecheck-field-checkmark"
                      alt="selected filecheck"
                      loading="lazy"
                    />
                  )}
                </Col>
                <Col
                  xs={9}
                  className={
                    "filecheck-field-details" +
                    (fileCheck.disabled ? " disabled" : "")
                  }
                >
                  <div className="filecheck-field-details-title">
                    <strong>{this.renderFileCheckTitle(fileCheck.key)}</strong>
                  </div>
                  <div className="filecheck-field-details-subtitle">
                    {fileCheck.description && (
                      <small>
                        {this.renderFileCheckDescription(fileCheck.key)}
                      </small>
                    )}
                    <span
                      className="text-remark"
                      id={`filecheck_${index}_id_details`}
                    >
                      {" "}
                      {this.context.t("Details")}
                    </span>
                  </div>
                </Col>
              </Row>
              <UncontrolledPopover
                trigger="hover"
                delay={{ show: 0, hide: 0 }}
                placement="right"
                target={`filecheck_${index}_id_details`}
              >
                <PopoverHeader>
                  {this.renderFileCheckTitle(fileCheck.key)}
                </PopoverHeader>
                <PopoverBody>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.renderPopoverContent(fileCheck.key),
                    }}
                  />
                </PopoverBody>
              </UncontrolledPopover>
            </div>
          );
        })}
        <Row>
          <div className="d-flex">
            <input
              type="radio"
              className="filecheck-field-nofilecheck-radio"
              checked={"no-filecheck" === value ? "checked" : ""}
              onChange={this.toggle}
              name="radio"
              id="radiobutton-nofilecheck"
            />
            <label
              className="filecheck-field-nofilecheck-label text-remark mt-3"
              htmlFor="radiobutton-nofilecheck"
            >
              {this.context.t("No Filecheck Description")}
            </label>
          </div>
          <p className="text-center w-100">
            <a
              href={`/${language}/fileguide/`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={fileguideIcon}
                alt={this.context.t("Production Data Guidelines")}
                height="18"
              />{" "}
              {this.context.t("Production Data Guidelines")}
            </a>
          </p>
          <Modal
            fade={false}
            isOpen={this.state.modal}
            toggle={this.toggle}
            className={this.props.className}
          >
            <ModalHeader toggle={this.toggle}>
              {this.context.t("NoFilecheck.alert.title")}
            </ModalHeader>
            <ModalBody>
              <div
                dangerouslySetInnerHTML={{
                  __html: this.context.t("NoFilecheck.alert.body"),
                }}
              />
              <p className="text-center mt-1">
                <a
                  href={`/${language}/fileguide/`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={fileguideIcon}
                    alt={this.context.t("Production Data Guidelines")}
                    height="20"
                  />{" "}
                  {this.context.t("Production Data Guidelines")}
                </a>
              </p>
            </ModalBody>
            <ModalFooter>
              <Button
                color="primary"
                onClick={this.setModalValue.bind(this, "filecheck")}
              >
                {this.context.t("Please do a file check")}
              </Button>{" "}
              <Button
                color="secondary"
                onClick={this.setModalValue.bind(this, "no-filecheck")}
              >
                {this.context.t("I understand")}
              </Button>
            </ModalFooter>
          </Modal>
        </Row>
      </div>
    );
  }
}

/**  define proptype for the 'translation' function  */
FileCheckField.contextTypes = {
  t: PropTypes.func,
};

export default FileCheckField;
